import { CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		placeItems: 'center',
		placeContent: 'center',
		width: '100vw',
		height: '100vh',
	},
}))

export default function Spinner() {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<CircularProgress />
		</div>
	)
}
